import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import LockIcon from "@material-ui/icons/Lock";

const useStyles = makeStyles(() => ({
  header: {
    fontSize: 28,
    marginTop: 40,
    marginBottom: 10,
    fontWeight: 400,
  },
  grid: {
    display: "flex",
  },
  details: {
    display: "flex",
    flexDirection: "column",
    height: 380,
    width: 300,
    position: "relative",
    marginRight: 10,
  },
  locked: {
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    position: "absolute",
    backgroundColor: "#000000",
    opacity: "0.7",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#BBBBBB",
  },
  lockedText: {
    marginLeft: 10,
    marginTop: 3,
  },
  content: {
    display: "flex",
    flexDirection: "row",
  },
}));

const Unlocks = ({ level }) => {
  const classes = useStyles();

  return (
    <>
      <Typography component="h2" variant="h2" className={classes.header}>
        Unlocks
      </Typography>
      <div className={classes.grid}>
        <div className={classes.details}>
          {level < 2 && (
            <div className={classes.locked}>
              <LockIcon />{" "}
              <Typography variant="h5" className={classes.lockedText}>
                Unlocks At Level 2
              </Typography>
            </div>
          )}
          <iframe
            title="Yr Throat"
            src="https://open.spotify.com/embed/track/6IMA3BHw2NPVLYb4J5oqFs"
            width="300"
            height="380"
            frameBorder="0"
            allowtransparency="true"
            allow="encrypted-media"
          ></iframe>
        </div>
        <div className={classes.details}>
          {level < 3 && (
            <div className={classes.locked}>
              <LockIcon />{" "}
              <Typography variant="h5" className={classes.lockedText}>
                Unlocks At Level 3
              </Typography>
            </div>
          )}
          <iframe
            title="dvp"
            src="https://open.spotify.com/embed/track/50OUltSwhS1CuwTJFhMgoB"
            width="300"
            height="380"
            frameBorder="0"
            allowtransparency="true"
            allow="encrypted-media"
          ></iframe>
        </div>
        <div className={classes.details}>
          {level < 4 && (
            <div className={classes.locked}>
              <LockIcon />{" "}
              <Typography variant="h5" className={classes.lockedText}>
                Unlocks At Level 4
              </Typography>
            </div>
          )}
          <div className={classes.content}>
            <iframe
              title="Death Cup"
              src="https://open.spotify.com/embed/track/1FxBWcrdZ5fzYmIFuUgBE2"
              width="300"
              height="380"
              frameBorder="0"
              allowtransparency="true"
              allow="encrypted-media"
            ></iframe>
          </div>
        </div>
      </div>
    </>
  );
};

export default Unlocks;
